// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';

type Props = {
  error: boolean,
  touched: boolean,
};

export default styled<any, Theme, Props>('div')`
  display: flex;
  ${props => props.error && props.touched && css`
    border: 1px solid ${props.theme.form.error.borderColor};
    border-radius: ${props.theme.form.error.fieldBorderRadius};
    padding: 0.5rem 0.75rem;
  `};
`;
